import { fetch } from "utils/dataAccess";

export function couponCodesList() {
    return fetch(`/picking/orders/coupon-codes`).then(response => response.json());
}
